import { Fragment, type ReactNode } from 'react';
import { useParams } from 'react-router-dom';

/**
 * Remounts its children whenever a route parameter changes.
 *
 * React Router keeps the same component instance when only a parameter
 * changes (/people/1 to /people/2). A detail page that seeds its form once
 * from the loaded record then goes on showing the first record under the
 * second one's URL, and a Save mixes the two (Resident Detail's form is the
 * first resident's while its diet order and allergy writes use the second
 * one's id). Keying the page by the parameter gives each record a fresh page,
 * the same as arriving from the list.
 */
export default function KeyedByRouteParam({ param, children }: { param: string; children: ReactNode }) {
  const params = useParams();
  return <Fragment key={params[param] ?? ''}>{children}</Fragment>;
}
